import { useEffect, useRef, useState } from 'react';
import { Object3D, Vector3, Vector3Tuple } from 'three';

import { closestPointInNavMesh, NavMeshQuery } from '@spazious/dollhouse-navmesh';
import { useStore } from '@spazious/dollhouse-store';
import { Instance } from '@spazious/dollhouse-three';

const _position = new Vector3();

const getFloorLevel = (
  position: Vector3Tuple,
  node: Object3D,
  navMeshQuery: NavMeshQuery,
  navMeshFloorOffset: number
): number => {
  _position.set(...position);
  node.parent?.localToWorld(_position);

  const result = closestPointInNavMesh(_position, navMeshQuery, { distance: 10 });

  _position.y = result.success ? result.point.y : 0;
  node.parent?.worldToLocal(_position);

  return _position.y + navMeshFloorOffset;
};

export const useFloorPosition = (position: Vector3Tuple) => {
  const navMeshQuery = useStore(({ world }) => world.navMeshQuery);
  const navMeshFloorOffset = useStore(({ world }) => world.navMeshFloorOffset);

  const nodeRef = useRef<Instance>(null);
  const [node, setNode] = useState<Instance | null>();

  const [floorPosition, setFloorPosition] = useState(position);

  useEffect(() => {
    if (nodeRef.current) {
      setNode(nodeRef.current);
    }
  }, []);

  // TODO - re-calculate floor position only if the world position of the node has changed
  useEffect(() => {
    let floorLevel = 0;
    if (node && navMeshQuery) {
      floorLevel = getFloorLevel(position, node, navMeshQuery, navMeshFloorOffset);
    }
    setFloorPosition([position[0], position[1] + floorLevel, position[2]]);
  }, [navMeshFloorOffset, navMeshQuery, node, position]);

  return { floorPosition, nodeRef };
};
